import { NoRecords } from "assets/svg"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export default function ErrorPage() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/', { replace: true })
  })

  return (
    <div
      className={'card flex-column is-vertical-center is-justified-center no-data has-text-centered has-padding-lg has-margin-top-sm'}
    >
      <NoRecords className="has-margin-bottom-lg" />
      <h5 className="text is-h5 is-bold has-margin-bottom-md">
        Route not found.
      </h5>
    </div>
  )
}
